import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ scope, scopeId }) =>
    present(repository.getProjectsElementsTags(scope, scopeId));
}

export type { Interactor };

export { createInteractor };
